import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

const Applications = () => {
  return (
    <Layout>
      <section id="greenorange-dest">
        <section className="banner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h1 className="mar0">Applications</h1>
                <p className="colorWht">As organizations are evolving into Digital Businesses, their application estate is set to take a giant leap.</p>
              </div>
            </div>
          </div>
        </section>
        <section className="content-dest">
          <div className="col-lg-12 content-dest-bg">
            <div className="col-lg-5 col-md-5 col-sm-6 padTB58 text-right">
              <img src="/images/applications.jpg" alt="applications" className="content-img" />
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 padTB58 padLR15">
              <p>
                As organizations are evolving into Digital Businesses, their application estate is set to take a giant leap. The 20th century was about building robust capabilities that allowed us to capture information from every commercial process like financial transactions, order processing, supply chain, human resources or anything that can help management with tangible insights. These were popularly termed as "systems of records."
                In the 21st century, we started increasingly looking for information that resided outside the perimeter of our organization with our partners, customers, resellers and subsidiaries in other countries. Our systems became more interactive, collaborative and easy to use and delivered personalized content.
              </p>
              <p>
                In a nutshell "Systems of Records" opened the doors for "Systems of Engagement" – giving users integrated, contextual, multi-channel access to transactions, content, collaboration, communications and driving actionable insights to deliver higher business performance.
              </p>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 bgwhite">
              <div className="dest-rightside app-page">
                <div>You may also be interested in <span> our other services</span></div>
                <ul className="pad0">
                  <li><Link to="/enterprise-resource-planning" title="ERP">ERP</Link></li>
                  <li><Link to="/consulting" title="Consulting">Consulting</Link></li>
                  <li><Link to="/mobility" title="Mobility">Mobility</Link></li>
                  <li><Link to="/business-process" title="Business Process">Business Process</Link></li>
                  <li><Link to="/gps-tracking-service" title="GPS Tracking as Service">GPS Tracking as Service</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <div className="clearfix"></div>
        <section className="content-dest1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h2>How Green Orange Helps?</h2>
                <p>
                  GreenOrange believes the Systems of Engagement landscape has a tendency to evolve quickly and pose myriad demands on the Systems of Records, thus making it important for a modern day enterprise to have:
                </p>
                <ul className="">
                  <li>Enhancing customer experience with Digital solutions</li>
                  <li>Business agility through process GreenOrange project management</li>
                </ul>
                <h4>Areas Covered</h4>
                <ul>
                  <li>Consulting</li>
                  <li>Enterprise and Custom Applications Support</li>
                  <li>Quality Assurance</li>
                  <li>Cloud and Mobility</li>
                  <li>Embedded Development</li>
                </ul>
                <p>Enterprise Application Services (EAS) practice at GreenOrange offers package and platform-led services to transform customer's business and IT operations.</p>
                <h2>Testing Services</h2>
                <p>
                  Customers expect to connect to businesses anytime, anywhere, on any device. More than before, application quality and performance are critical to succeed in today's digital, 'always-on' world. Most organizations are responding by an increased focus on quality, although many testing practices are struggling to adapt to the changing demands from digital transformation.
                </p>
                <p>GreenOrange Testing Services clients benefit from:</p>
                <ul>
                  <li>Total cost of testing reduced by up to 30%</li>
                  <li>Quality levels improved by preventing more than 98% of high-severity defects</li>
                  <li>Time to market decreased by at least 15%</li>
                  <li>Technical and business risks significantly mitigated</li>
                </ul>
                <h4>Areas Covered</h4>
                <ul>
                  <li>Application Testing</li>
                  <li>Managed Testing Services</li>
                  <li>Mobile Testing</li>
                  <li>Agile Methodology</li>
                  <li>Embedded Development</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default Applications;

